import script from "./WizardProgressStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardProgressStep.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__